<template>
  <section class="container bottom-margin" aria-label="404 - Page Not Found">
    <vue-headful
      :head="{
        'meta[name]': { name: 'robots', content: 'noindex' },
      }"
    ></vue-headful>
    <div class="col-lg-12 mt-5">
      <h1>This Campaign Cannot Be Found</h1>
      <p>We could not find the campaign you were looking for.</p>
      <p>Please feel free to search for other possibilites as well.</p>
    </div>
  </section>
</template>
<script>
import { Vue, Component } from 'vue-property-decorator';

@Component({
  data() {
    return {};
  },
})
class NotFoundCampaign extends Vue {}

export default NotFoundCampaign;
</script>

<style lang="scss" scoped>
h2 {
  font-size: 2rem;
  margin: 50px 0;
}
h3 {
  font-size: 20px;
  margin-bottom: 20px;
}
.bottom-margin {
  margin-bottom: 60px;
}
.event-search-input {
  border: none;
  border-bottom: solid 2px #979797;
  border-radius: 0px;
  font-style: italic;
}
.events-filter-btn {
  margin-left: 20px;
}
.filters-wrapper {
  border-radius: var(--spacing-xs) var(--spacing-xs) 0 0;
  width: 45%;
  margin: auto;
  background-color: #ffffff;
  padding: 40px;
  margin-bottom: 54px;
  margin-top: -270px;
}
.skip {
  -webkit-transition: opacity 0.2s;
  transition: opacity 0.2s;
  left: -999em;
  top: 15px;
  z-index: 9999;
  opacity: 0;
  position: absolute !important;
  padding: 15px 25px 10px 25px !important;
}
.skip:focus {
  opacity: 1;
  left: 15px;
}
.custom-select {
  border: 1px solid #4e97b2;
  font-family: 'klinicslabbold';
  color: #173945;
  background: url('/images/misc/down-arrow.svg');
  background-size: 25px;
  background-repeat: no-repeat;
  background-position: right 10px center;
  fill: #173945;
  content: '\e904';
  color: #173945;
  min-width: 200px;
  max-width: 200px;
  display: inline-block;
  background-color: #fff;
}
.custom-select-show-me {
  min-width: 300px;
  max-width: 300px;
}
.form-control {
  display: inline-block;
  width: 60%;
}
h2 {
  display: inline-block;
  line-height: 3rem;
}
select {
  margin-bottom: 1rem;
}
.icon-search-icon {
  border: none;
  border-bottom: solid 2px #979797;
  border-radius: 0px;
  content: '';
  color: #4e97b2;
}
.events-filter-btn {
  margin-left: 20px;
}
.icon-search-icon:before {
  content: '\e909';
  font-weight: 200;
  font-size: 1.8rem;
  padding-right: 1px;
  z-index: 2;
}
button.icon-search-icon {
  border: none;
  color: #4e97b2;
  background: transparent;
}
button.icon-search-icon:hover {
  border: none;
  color: #000;
  background: transparent;
}
.event-search-input {
  border: none;
  border-bottom: solid 2px #979797;
  border-radius: 0px;
  font-style: italic;
}
@media only screen and (max-width: 1530px) {
  .filters-wrapper {
    width: 50%;
  }
}
@media only screen and (max-width: 1375px) {
  .in-wrapper {
    display: block;
  }
}
@media only screen and (max-width: 1294px) {
  .happening-text {
    display: block;
  }
  .in-wrapper {
    display: block;
  }
  .custom-select-show-me,
  .custom-select-happening {
    min-width: 100%;
    max-width: 100%;
  }
  .custom-select-in {
    min-width: 84%;
    max-width: 84%;
  }
  .form-control {
    width: 50%;
  }
}
@media only screen and (max-width: 1000px) {
  .form-control {
    width: 80%;
  }
  .events-filter-btn {
    margin: 20px auto;
    width: 150px;
  }
}
@media only screen and (max-width: 768px) {
  .filters-wrapper {
    width: 80%;
    margin: auto;
    margin-top: -260px;
    background-color: #ffffff;
    padding: 10px;
    margin-bottom: 54px;
    margin-top: 0px;
  }
}

.btn-secondary {
  color: #fff;
  background-color: #4e97b2;
  border-color: #4e97b2;
}
</style>
